<script lang="ts">
    import { TOUR_TYPE_GIR, TYPEBOOKING_EBOOKING } from '$saga/constants/tour';
    import { AgeRules, DateInfos, FormValues } from '$saga/views/Tour/types';
    import ChildrenInput from './ChildrenInput.svelte';
    import AdultsInput from './AdultsInput.svelte';

    export let tourType: number;
    export let bookingType: string;
    export let isTravelAloneAuthorized: boolean;
    export let minAgeAllowed: number;
    export let maxAgeAllowed: number;
    export let formValues: FormValues;
    export let childrenAges: string[];
    export let ageRules: AgeRules;
    export let datesInfos: DateInfos;

    const isEbookingType = bookingType === TYPEBOOKING_EBOOKING;
    const isGir = tourType === TOUR_TYPE_GIR;
    const isChildrenAllowed =
        isEbookingType &&
        (minAgeAllowed < 18 || (maxAgeAllowed && maxAgeAllowed < 18));

    let maxAdultsRuleValue =
        isEbookingType && isGir
            ? formValues.selectedDate &&
              datesInfos?.remainingStock &&
              datesInfos.remainingStock - formValues.children
            : null;
    let maxChildrenRuleValue =
        isGir && isChildrenAllowed && datesInfos.remainingStock
            ? datesInfos.remainingStock - formValues.adults
            : null;

    $: {
        maxAdultsRuleValue =
            isEbookingType && isGir
                ? formValues.selectedDate &&
                  datesInfos?.remainingStock &&
                  datesInfos.remainingStock - formValues.children
                : null;
        maxChildrenRuleValue =
            isGir && datesInfos.remainingStock
                ? datesInfos.remainingStock - formValues.adults
                : null;
    }
</script>

<div class="mx-xl flex h-full flex-col gap-xl pt-2xl">
    <!-- Existing adult/child selector content here -->
    <AdultsInput
        {isTravelAloneAuthorized}
        {minAgeAllowed}
        {maxAgeAllowed}
        {tourType}
        {bookingType}
        bind:formValues
        {ageRules}
        maxRuleValue={maxAdultsRuleValue}
        dateStatusName={datesInfos?.statusName ?? ''}
    />
    {#if isEbookingType && isChildrenAllowed}
        <ChildrenInput
            {minAgeAllowed}
            {maxAgeAllowed}
            bind:formValues
            {ageRules}
            {childrenAges}
            maxRuleValue={maxChildrenRuleValue}
        />
    {/if}
    {#if datesInfos?.remainingStock}
        <div class="text-center">
            Il reste
            <span class="font-semibold">
                {datesInfos.remainingStock} place{datesInfos.remainingStock > 1
                    ? 's'
                    : ''}</span
            >
            pour ce départ.
        </div>
    {/if}
</div>
